import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Snackbar, Alert } from "@mui/material";
import { hideNotification } from "../../Redux/Notification/NotificationSlice";

const Notification = () => {
  const dispatch = useDispatch();
  const notification = useSelector((state) => state.notification);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(hideNotification());
  };

  return (
    <Snackbar
      open={notification.open}
      autoHideDuration={5000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      sx={{
        '& .MuiSnackbar-root': {
          width: '100%',
          maxWidth: '600px'
        }
      }}
    >
      <Alert
        onClose={handleClose}
        severity={notification.type}
        variant="filled"
        sx={{
          width: '100%',
          minWidth: '400px',
          fontSize: '1.1rem',
          padding: '12px 20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          '& .MuiAlert-message': {
            fontWeight: 500
          }
        }}
      >
        {notification.message}
      </Alert>
    </Snackbar>
  );
};

export default Notification;
